<template>
  <Modal
    :modal="modal"
    :loading="loading"
    :hasActions="false"
    :fixedTitle="true"
    title="Selecione o Produto"
    @close="$emit('close')"
    @save="save"
    @refresh="getProdutosAPI"
    fullscreen
    cardTitleClass="primary white--text"
  >
    <template slot="title">
      <div>
        <v-icon
          left
          dark
          @click="$emit('close')"
        >mdi-arrow-left</v-icon>
        Produto
      </div>
      <div>
        <v-btn dark text @click="save">
          Salvar
        </v-btn>
        <Menu
          :items="menuItems"
          dark
          @buscaProdutos="getProdutosAPI"
          @removeProduto="$emit('remove', produto)"
        />
      </div>
    </template>
    
    <CardTitle title="Informações" class="mb-4">
      <v-row no-gutters>
        <v-col cols="12" class="pt-0">
          <ModalProdutoSelect
            :modal="modalProdutoSelect"
            :tabelaPreco="tabelaPreco"
            @close="modalProdutoSelect = false"
            @save="changeProduto"
          />
          <v-form v-model="valid" ref="formProduto" lazy-validation>
            <v-autocomplete
              v-model="produto.descricao"
              :items="produtos"
              item-text="descricao"
              return-object
              label="Produto"
              no-data-text="Nenhum registro encontrado"
              :loading="loading"
              @change="changeProduto"
              :rules="[rules.required]"
              readonly
              @click="modalProdutoSelect = true"
            ></v-autocomplete>
            <v-autocomplete
              v-if="produto.unidades_saida && produto.unidades_saida.length"
              v-model="produto.unidade"
              :items="produtoUnidadesSaida"
              item-text="unidade"
              return-object
              label="Unidade"
              no-data-text="Nenhum registro encontrado"
              @change="changeUnidade"
              :rules="[rules.required]"
            ></v-autocomplete>
            <v-text-field
              class="text-right-input"
              type="number"
              v-model="produto.qtde_produto"
              append-outer-icon="mdi-plus"
              @click:append-outer="increaseQt"
              prepend-icon="mdi-minus"
              @click:prepend="decreaseQt"
              label="Quantidade"
              @change="changeQuantidade"
              :disabled="!produto.id_produto"
              :rules="[rules.greaterThanZero]"
            ></v-text-field>
            <v-text-field
              class="text-right-input"
              :disabled="!produto.id_produto"
              type="number"
              v-model.number="produto.preco_bruto"
              label="Preço"
              @change="changePreco"
              :rules="[rules.greaterThanZero]"
            ></v-text-field>
            <div class="d-flex justify-space-between align-center">
              <v-col class="pl-0 py-0">
                <v-text-field
                  class="text-right-input"
                  :disabled="!produto.id_produto"        
                  type="number"
                  v-model.number="produto.desconto"
                  label="Desconto"
                  @change="changeDesconto"
                  :rules="[rules.zeroOrGreater]"
                ></v-text-field>
              </v-col>
              <v-col class="pr-0 py-0">
                <v-text-field
                  class="text-right-input"
                  :disabled="!produto.id_produto"        
                  type="number"
                  v-model.number="produto.perc_desconto"
                  label="Percentual"
                  @change="changePercDesconto"
                  :rules="[rules.zeroOrGreater]"
                ></v-text-field>
              </v-col>
            </div>
          </v-form>
        </v-col>
      </v-row>
    </CardTitle>
    <v-row v-if="produto.id_produto">
      <v-col cols="12" class="py-0">
        <CardTitle
          title="Resumo"
          class="mb-4"
          :hideCard="hideResumo"
        >
          <v-btn
            slot="actions"
            text
            fab
            small
            @click="hideResumo = !hideResumo"
          >
            <v-icon>{{ hideResumoIcon }}</v-icon>
          </v-btn>
          <div class="d-flex justify-space-between align-center">
            <span>Preço Unitário</span>
            <p class="font-weight-bold mb-0">{{ produto.preco_unitario | price }}</p>
          </div>
          <v-divider class="my-1"></v-divider>
          <div class="d-flex justify-space-between align-center">
            <span>Subtotal Bruto</span>
            <p class="font-weight-bold mb-0">{{ produto.subtotal_bruto | price}}</p>
          </div>
          <v-divider class="my-1"></v-divider>
          <div class="d-flex justify-space-between align-center red--text">
            <span>Desconto</span>
            <p class="font-weight-bold mb-0">{{ produto.desconto | price }}</p>
          </div>
          <v-divider class="my-1"></v-divider>
          <div class="d-flex justify-space-between align-center">
            <span>Subtotal</span>
            <p class="font-weight-bold mb-0">{{ produto.subtotal | price }}</p>
          </div>
          <v-divider class="my-1"></v-divider>
        </CardTitle>
        <CardTitle
          title="Observações"
          :hideCard="hideObservacoes"
        >
        <v-btn
          slot="actions"
          text
          fab
          small
          @click="showObservacoes"
        >
          <v-icon>{{ hideObservacoesIcon }}</v-icon>
        </v-btn>
          <v-textarea
            v-model="produto.observacoes"
            rows="2"
            auto-grow
            id="produto-observacoes"
            class="pt-0 mt-0"
            hide-details
          ></v-textarea>
        </CardTitle>
      </v-col>
    </v-row>
  </Modal>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import Modal from '@/components/shared/Modal';
import ModalProdutoSelect from '@/components/shared/ModalProdutoSelect';
import Produto from '@/domain/Produto';

export default {
  name: 'ModalProduto',
  props: {
    modal: {
      type: Boolean,
      default: false
    },
    editProduto: {
      default: null
    },
    tabelaPreco: {
      default: null
    }
  },
  components: {
    Modal,
    Menu: () => import('@/components/shared/Menu'),
    CardTitle: () => import('@/components/shared/CardTitle'),
    ModalProdutoSelect
  },
  data: () => ({
    modalProdutoSelect: false,
    loading: false,
    valid: true,
    produto: new Produto(),
    unidadePadrao: null,
    hideObservacoes: true,
    hideResumo: false,
    menuItems: [
      // { title: 'Buscar Produtos', value: 'buscaProdutos' },
      { title: 'Remover', value: 'removeProduto', color: 'red--text' },
    ]
  }),
  watch: {
    modal(value) {
      if (value && !this.produtos.length && !this.unidades.length && !this.loading) {
        this.getProdutos();
        this.getUnidades();
      } else {
        this.produto = new Produto();
        this.unidadePadrao = null;
      }
    },
    editProduto(value) {
      if (value) {
        this.produto = value;
        this.changeProduto(value);
      }
    }
  },
  computed: {
    ...mapGetters(['unidades', 'produtos', 'rules', 'incrementQtdeBy']),
    hideResumoIcon() {
      return this.hideResumo ? 'mdi-chevron-down' : 'mdi-chevron-up';
    },
    hideObservacoesIcon() {
      return this.hideObservacoes ? 'mdi-chevron-down' : 'mdi-chevron-up';
    },
    produtoUnidadesSaida() {
      if (this.produto.unidades_saida && this.produto.unidades_saida.length) {
        const unidadesArray = [...this.produto.unidades_saida];
        unidadesArray.push(this.unidadePadrao);
        return unidadesArray;
      } else {
        return [];
      }
    },
  },
  methods: {
    ...mapActions(['fetchUnidades', 'fetchUnidadesAPI', 'fetchProdutos', 'fetchProdutosAPI']),
    ...mapMutations(['SHOW_SNACKBAR']),
    showObservacoes() {
      this.hideObservacoes = !this.hideObservacoes;
      this.$nextTick(() => document.querySelector('#produto-observacoes').focus());
    },
    changePercDesconto() {
      if (this.produto.perc_desconto < 0 || this.produto.perc_desconto > 99.9) {
        this.produto.perc_desconto = 0;
        this.calculaTotalItem();
        this.SHOW_SNACKBAR({ text: 'Percentual inválido.', status: 'error' });
        return;
      }
      this.produto.desconto = (this.produto.subtotal_bruto * (this.produto.perc_desconto / 100)).toFixed(2);
      this.calculaTotalItem();
    },
    changeDesconto() {
      if (this.produto.desconto < 0 || this.produto.desconto >= this.produto.subtotal_bruto) {
        this.produto.desconto = 0;
        this.calculaTotalItem();
        this.SHOW_SNACKBAR({ text: 'Desconto inválido.', status: 'error' });
        return;
      }
      this.calculaTotalItem();
    },
    changePreco() {
      if (this.produto.preco_bruto <= 0) {
        this.produto.preco_bruto = this.produto.preco_original;
        this.calculaTotalItem();
        this.SHOW_SNACKBAR({ text: 'Preço de venda inválido.', status: 'error' });
        return;
      }
      if (this.produto.preco_bruto <= this.produto.preco_original) {
        this.produto.desconto = (this.produto.qtde_produto * this.produto.preco_original) - (this.produto.qtde_produto * this.produto.preco_bruto);
        this.produto.preco_bruto = this.produto.preco_original;
      }

      this.calculaTotalItem();
    },
    calculaTotalItem() {
      if (this.produto.preco_bruto <= 0) return;
      this.produto.subtotal_bruto = this.produto.preco_bruto * this.produto.qtde_produto;
      this.produto.subtotal = this.produto.subtotal_bruto - this.produto.desconto;
      this.produto.preco_unitario = this.produto.subtotal / this.produto.qtde_produto;
      this.produto.perc_desconto = (this.produto.desconto / this.produto.subtotal_bruto * 100).toFixed(2);
    },
    periodoTabelaPrecoValido() {
      const hoje = new Date(new Date().setHours(0, 0, 0, 0));
      const [anoInicial, mesInicial, diaInicial] = this.tabelaPreco.data_inicial.substr(0, 10).split('-');
      const [anoFinal, mesFinal, diaFinal] = this.tabelaPreco.data_final.substr(0, 10).split('-');
      const dtInicial = new Date(anoInicial, mesInicial - 1, diaInicial).getTime();
      const dtFinal = new Date(anoFinal, mesFinal - 1, diaFinal).getTime();

      return hoje >= dtInicial && hoje <= dtFinal;
    },
    preparaPrecosProdutoTabelaPreco() {
      if (!this.tabelaPreco) return;

      const produtoTabelaPreco = this.tabelaPreco.itens.find(
        produto => produto.id_produto == this.produto.id_produto && produto.id_unidade === this.produto.id_unidade
      );
      
      if (produtoTabelaPreco && this.periodoTabelaPrecoValido()) {
        this.produto.preco_original = produtoTabelaPreco.preco_venda;
        this.produto.preco_bruto = produtoTabelaPreco.preco_venda;
        this.produto.id_tabela_preco = this.tabelaPreco.id_tabela_preco;
      }
    },
    changeProduto(obj) {
      this.produto.id_produto = obj.id_produto;
      this.produto.descricao = obj.descricao;
      this.produto.id_unidade = obj.id_unidade;
      this.produto.unidade = obj.unidade;
      this.produto.preco_original = obj.preco_bruto;
      this.produto.preco_bruto = obj.preco_bruto;
      this.preparaPrecosProdutoTabelaPreco();
      this.produto.qtde_produto = obj.qtde_produto || 1;
      this.produto.desconto = obj.desconto || 0;
      this.produto.preco_unitario = obj.preco_bruto;
      // this.desconto = obj.desconto ? this.desconto = obj.desconto / obj.qtde_produto : this.desconto = 0;
      this.produto.unidades_saida = obj.unidades_saida || [];

      // Salva a unidade padrão que vem no produto
      // para quando o produto tiver unidades de saída
      // ela possa ser selecionada
      this.unidadePadrao = {};
      this.unidadePadrao.id_unidade = obj.id_unidade;
      this.unidadePadrao.unidade = obj.unidade;
      this.unidadePadrao.preco_venda = obj.preco_bruto;

      this.calculaTotalItem();
      this.modalProdutoSelect = false;
    },
    changeUnidade(obj) {
      this.produto.id_unidade = obj.id_unidade;
      this.produto.unidade = obj.unidade;
      this.produto.qtde_unidade = obj.qtde_unidade;
      this.produto.preco_original = obj.preco_venda;
      this.produto.preco_bruto = obj.preco_venda;
      this.preparaPrecosProdutoTabelaPreco();
      this.calculaTotalItem();
    },
    changeQuantidade(obj) {
      this.produto.qtde_produto = obj;
      if (this.produto.qtde_produto <= 0) this.produto.qtde_produto = 1;
      this.produto.desconto = 0;
      this.calculaTotalItem();
    },
    getUnidades() {
      this.loading = true;
        this.fetchUnidades()
          .then(() => this.loading = false);
    },
    getUnidadesAPI() {
      this.loading = true;
        this.fetchUnidadesAPI()
          .then(() => this.loading = false);
    },
    getProdutos() {
      this.loading = true;
        this.fetchProdutos()
          .then(() => this.loading = false);
    },
    getProdutosAPI() {
      this.loading = true;
        this.fetchProdutosAPI()
          .then(() => {
            this.produto = new Produto();
            this.unidadePadrao = null;
            this.loading = false;
          });
    },
    decreaseQt() {
      this.produto.qtde_produto = Number(this.produto.qtde_produto) - this.incrementQtdeBy;
      if (this.produto.qtde_produto <= 0) this.produto.qtde_produto = 1;
      this.produto.desconto = 0;
      this.calculaTotalItem();
    },
    increaseQt() {
      this.produto.qtde_produto = Number(this.produto.qtde_produto) + this.incrementQtdeBy;
      this.produto.desconto = 0;
      this.calculaTotalItem();
    },
    prepareProduto() {
      return { ...this.produto };
    },
    validateForm() {
      return this.$refs.formProduto.validate();
    },
    save() {
      if (!this.editProduto && this.validateForm()) {
        const newProduct = this.prepareProduto();
        this.$emit('save', newProduct);
        this.produto = new Produto();
      } else if (this.editProduto && this.validateForm()) {
        const editProduto = this.prepareProduto();
        this.$emit('update', editProduto);
        this.produto = new Produto();
      }
    }
  }
}
</script>

<style scoped>
.text-right-input >>> input {
  text-align: right;
}
</style>